module.exports = __webpack_public_path__ + "static/timeline1995-e9715d3af04068d6b895fffde7fc748f.jpeg";